import { DocumentationItem } from '../common/definitions';
import { AppState } from '../root-reducer';
import { InterviewState, InterviewTableRow } from './definitions';

export const selectInterview = (state: AppState): InterviewState => state.interviewsReducer;
export const selectIsLoading = (state: AppState): boolean => selectInterview(state).loading;
export const selectTableData = (state: AppState): InterviewTableRow[] => selectInterview(state).interviewTableData;
export const selectGetInterviewDocumentation = (state: AppState): DocumentationItem[] =>
  selectInterview(state).documentation;
